import React from 'react';
import Section from 'evcharging/containers/layout/Section';
import Container from 'evcharging/components/Container';
import Baget from 'evcharging/components/Baget';
import Spacer from 'evcharging/components/Spacer';
import OccpHeader from 'evcharging/containers/ocpp/OccpHeader';
import Paragraph from 'evcharging/components/Paragraph';
import LinkButton from 'evcharging/components/LinkButton';
import { CONTACT_US_ANCHOR } from 'evcharging/app/seo/urls';
import Mobile from 'evcharging/components/Mobile';
import useI18n from 'evcharging/hooks/useI18n';

const WhatIsOpenADR = () => {
  const { t } = useI18n();

  return (
    <Section>
      <Container>
        <Spacer value={50} mobile={90} />
        <Baget>{t('open.label')}</Baget>
        <Spacer value={24} />
        <OccpHeader>{t('open.header')}</OccpHeader>
        <Spacer value={24} />
        <Paragraph color={'middle'}>{t('open.intro')}</Paragraph>
        <Mobile>
          <Spacer value={30} />
          <LinkButton href={CONTACT_US_ANCHOR}>{t('ocpp.schedule')}</LinkButton>
        </Mobile>
        <Spacer value={0} mobile={80} />
      </Container>
    </Section>
  );
};

export default WhatIsOpenADR;
